module.exports = __webpack_public_path__ + "img/label_outline.ec4d3b51.svg";